import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { OperationType, ROUTE_PATH, USER_TYPE, USERTYPE } from 'common/constants/sm-constants';
import {
  DataModel,
  ResolverResponseModel,
  RouteEnvelope,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import {
  GridParams,
  GridWidgetModel,
} from 'common/models/utility-models/list-utility.model';
import { BaseWidgetService } from 'common/widget/base-widget.service';

export abstract class BaseResolver<T extends DataModel>
  implements Resolve<any> {
  constructor(
    public pageService: BaseWidgetService<T>,
    protected router: Router
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    let routeMessage;
    return new Promise((resolve, reject) => {
      Promise.resolve()
        .then(() => {
          return Promise.resolve(this.getResolverMessage());
        })
        .then((message) => {
          routeMessage = message;
          if (route.queryParams['id']) {
            message.transferData.transferData = route.queryParams['id'];
          }

          return this.getDataBaseOnMessage(message);
        })
        .then((res) => {
          let dataRes;
          dataRes = res;
          const meta = this.getMetaForComponent();
          const widget = this.initWidget(
            routeMessage.type,
            routeMessage.transferData,
            dataRes,
            meta
          );
          return this.prepareResolveData(dataRes, meta, widget);
        })
        .then((finalRes) => {
          resolve(finalRes);
        })
        .catch((err) => {
          console.log(err);
          // if (this.getUserRole() === 1 || this.getUserRole() === 4) {
          //   this.navigateToDashboard();
          // } else {
          //   const userType = this.getUserType();
          //   this.navigateToProfile(userType);
          // }
          reject(err);
        });
    });
  }

  getDataBaseOnMessage(message: RouteEnvelope, body: any = ''): Promise<any> {
    return new Promise((resolve, reject) => {
      let promise;
      switch (message.type) {
        case OperationType.UPDATE:
          promise = this.pageService.getDataById(
            this.createQueryParams(message.transferData)
          );
          break;
        case OperationType.CREATE:
          promise = Promise.resolve(this.pageService.getDataModel());
          break;
        case OperationType.VIEW:
          promise = this.pageService.getListDataModel(
            this.createQueryParams(message.transferData)
          );
          break;
        case OperationType.MULTIUTILITY:
          promise = this.pageService.getDataFromMultipleAPI();
      }

      Promise.all([promise])
        .then((res) => {
          resolve(res[0]);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  initWidget(envelopeType, transferData, dataRes, meta): WidgetModel {
    if (envelopeType === OperationType.VIEW) {
      const widget = new GridWidgetModel();
      const metaModel = this.pageService.getMetaModel();
      widget.recordPerPage = metaModel.properties?.recordPerPage;
      widget.searchableFeilds = metaModel.properties?.searchableFields;
      widget.transferData = transferData;
      return widget;
    } else {
      const widget = new WidgetModel();
      widget.transferData = transferData;
      return widget;
    }
  }

  createQueryParams(paramsData: any): any {
    return paramsData;
  }

  getMetaForComponent() {
    return this.pageService.getMetaModel();
  }

  prepareResolveData(
    data: any,
    meta: any,
    widget: any
  ): Promise<ResolverResponseModel> {
    return new Promise<ResolverResponseModel>((resolve, reject) => {
      this.pageService
        .prepareMetaModel(data, meta, widget)
        .then((modifiedMeta) => {
          const responseType = new ResolverResponseModel();
          const dataModel = this.modifyResponseData(data, modifiedMeta, widget);
          responseType.data = dataModel;
          responseType.meta = modifiedMeta;
          responseType.widget = widget;
          resolve(responseType);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  }

  modifyResponseData(dataModel, meta, widget) {
    return dataModel;
  }

  getResolverMessage() {
    try {
      const route = this.manageState();
      const routerConfig = new RouteEnvelope();
      if (route !== null) {
        routerConfig['type'] = route['type'];
        routerConfig['transferData'] = route['transferData'];
        return routerConfig;
      } else {
        return JSON.parse(localStorage.getItem('routeEnvelope'));
      }
    } catch (err) {
      return JSON.parse(localStorage.getItem('routeEnvelope'));
    }

  }

  // manageState() {
  //   if (this.router.getCurrentNavigation().extras.state === undefined) {
  //     const envelope = new RouteEnvelope();
  //     envelope.type =
  //       localStorage.getItem('profile') !== null ||
  //       localStorage.getItem('currentUser') !== null
  //         ? OperationType.MULTIUTILITY
  //         : OperationType.CREATE;
  //     envelope.transferData = new WidgetModel();

  //     return envelope;
  //   } else {
  //     return this.router.getCurrentNavigation().extras.state;
  //   }
  // }

  // manageState() {
  //   const currentNav = this.router.getCurrentNavigation();
  //   const extrasState = currentNav ? currentNav.extras.state : undefined;
  //   console.log(this);
  //   if (extrasState === undefined) {
  //     const storedState = localStorage.getItem("routeEnvelope");
  //     console.log(storedState, 'storedState');
  //     if (storedState) {
  //       // localStorage.removeItem("routeEnvelope");
  //       console.log('storedState', storedState)
  //       if(this['fs']['queryparm']['type'] && storedState['type'] !== this['fs']['queryparm']['type']) {
  //         const type = this['fs']['queryparm']['type'];
  //         if(type === OperationType.VIEW) {
  //           const envelope = new RouteEnvelope();
  //           envelope.type = OperationType.VIEW;
  //           envelope.transferData = new GridParams(); 
  //           return envelope;   
  //         }  else {
  //           return JSON.parse(storedState) as RouteEnvelope;
  //         }
  //       } else {
  //         return JSON.parse(storedState) as RouteEnvelope;
  //       }
  //     } else {
  //       // this.router.navigate(["/dashboard"]);
  //       const userRole = JSON.parse(localStorage.getItem("loginData")).role;
  //       if (userRole === "1" || userRole === "4") {
  //         const envelope = new RouteEnvelope();
  //         envelope.type = OperationType.VIEW;
  //         envelope.transferData = new GridParams();
  //         return envelope;
  //       } else {
  //         // console.log('inside this block')
  //         this.router.navigate(["/dashboard"]);
  //       }
  //       return JSON.parse(storedState) as RouteEnvelope;
  //       // this.ss.navigateByUrl(ROUTE_PATH.adminDashboard, envelope);

  //     }
  //   } else {
  //     // console.log("State found:", extrasState);
  //     return extrasState;
  //   }
  // }

  manageState(): any {
    const currentNav = this.router.getCurrentNavigation();
    const extrasState = currentNav ? currentNav.extras.state : undefined;
    if (extrasState) {
      return extrasState;
    }
    const storedState = this.getStoredState();
    //console.log(storedState);
    if (storedState) {
      const queryType = this.getQueryParamType();
      if (queryType && storedState.type !== queryType) {
        return this.createRouteEnvelopeFromType(queryType);
      }
      return storedState;
    } else {
      const userRole = this.getUserRole();
      if (userRole === 1 || userRole === 4) {
        return this.createRouteEnvelopeFromType(OperationType.VIEW);
      }
      console.log(userRole);
      if (userRole !== 1 && userRole !== 4) {
        this.navigateToProfile();
      } else {
        this.navigateToDashboard();
      }
      return null;
    }
  }

  navigateToProfile(type: any = USER_TYPE.student) {
    const envelope = new RouteEnvelope();
    envelope.type = OperationType.UPDATE;
    envelope.transferData = new WidgetModel();
    this.router.navigate([type === USER_TYPE.student ? ROUTE_PATH.student_profile : type === USER_TYPE.trainer ? ROUTE_PATH.trainersStudentForm : ROUTE_PATH.alumniForm], {
      state: envelope,
      replaceUrl: true,
      onSameUrlNavigation: 'reload' // Add this to handle same-URL navigation
    })
    // this.navigateByUrl(ROUTE_PATH.student_profile, envelope);
  }

  private getStoredState(): RouteEnvelope | null {
    const storedState = localStorage.getItem("routeEnvelope");
    if (storedState) {
      try {
        return JSON.parse(storedState) as RouteEnvelope;
      } catch (error) {
        console.error("Invalid stored state:", error);
        localStorage.removeItem("routeEnvelope");
      }
    }
    return null;
  }

  private getQueryParamType(): string | null {
    return this['fs']?.['queryparm']?.['type'] || null;
  }

  private getUserRole(): any {
    const loginData = localStorage.getItem("loginData");
    return loginData ? JSON.parse(loginData).role : null;
  }

  private createRouteEnvelopeFromType(type: any): RouteEnvelope {
    const envelope = new RouteEnvelope();
    envelope.type = type;
    console.log(type)
    if (type === OperationType.VIEW) {
      envelope.transferData = new GridParams();
    } else {
      envelope.transferData = new WidgetModel(); // Use an empty object for other types
    }

    return envelope;
  }

  getUserType() {
    // let user = USER_TYPE.admin;
    const apiRes = JSON.parse(localStorage.getItem('loginData'))
    if (apiRes.userType === 2 && apiRes.status === 1) {
      return USER_TYPE.student;
    } else if (apiRes.userType === 2 && apiRes.status === 2) {
      return USER_TYPE.inactiveStudent;
    } else if (apiRes.userType === 2 && apiRes.status === 3) {
      return USER_TYPE.alumni;
    } else {
      return apiRes.userType;
    }
  }

  navigateToDashboard() {
    console.log('inside base resolver')
    const envelope = new RouteEnvelope();
    envelope.type = OperationType.VIEW;
    envelope.transferData = new GridParams();
    this.router.navigate([ROUTE_PATH.adminDashboard], {
      state: envelope,
      replaceUrl: true,
      onSameUrlNavigation: 'reload' // Add this to handle same-URL navigation
    })
    // this.navigateByUrl(ROUTE_PATH.adminDashboard, envelope);
  }

  // getEnvelopeByType(type: OperationType) {
  //   let envelope = new RouteEnvelope();
  //   switch(type) {
  //     case OperationType.CREATE:
  //       envelope.type = type;
  //       envelope.transferData = new WidgetModel();
  //       return envelope;
  //     case OperationType.VIEW:
  //       envelope.type = type;
  //       envelope.transferData = new GridParams();
  //       return envelope;
  //   }

  // }
}
